import useFetchOperatorMetadata from 'queries/fetch/fetchOperatorsMetadata.ts';
import useFetchAttributesMetadata from 'queries/fetch/fetchAttributesMetadata.ts';
import useFetchTeamCohorts from 'queries/fetch/fetchTeamCohorts.ts';
import { useParams } from 'react-router-dom';

const useReferenceData = () => {
  const { teamId } = useParams();
  const fetchOperatorMetadata = useFetchOperatorMetadata();
  const fetchTeamSpecificCohorts = useFetchTeamCohorts({ teamId });
  const fetchAttributeMetadata = useFetchAttributesMetadata();

  return {
    referenceData: {
      cohorts: fetchTeamSpecificCohorts.data?.cohorts.CohortRefData || [],
      attributes: fetchAttributeMetadata.data?.AttributeRefData || [],
      operators: fetchOperatorMetadata.data?.OperatorRefData || [],
    },
  };
};

export default useReferenceData;
